import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate"]

  connect() {
    this.updateEndDateMin()
  }

  updateEndDateMin() {
    const startValue = this.startDateTarget.value
    if (startValue) {
      if (this.endDateTarget.value && this.endDateTarget.value < startValue) {
        this.endDateTarget.value = startValue
      }
    }
  }
}
